import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Cadastro } from '../interfaces/cadastro';

import { FatDoctoC } from '../interfaces/fat-docto-c';
import { MovtoDetails } from '../interfaces/movto-details';
import { Endereco } from '../interfaces/endereco';
import { Observable, of } from 'rxjs';
import { PageResult } from '../interfaces/page-result';

import * as cnpjValidator from '@fnando/cnpj';
import { JwtAuthService } from './auth/jwt-auth.service';
import { Parameters } from '../interfaces/parameters';
import { log } from 'console';

/**
 * AJ 
 */

@Injectable({
  providedIn: 'root'
})
export class ParametroService {

  readonly path = '/param';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}


  saveOrUpdate(parametros: Parameters): Observable<any> {
    return this.http.put<Parameters>(`${this.jwtAuthService.apiUrl + this.path}`, parametros);
  }

  
  getParametros(filialPadraoId: number): Observable<Parameters> {
    return this.http.get<Parameters>(`${this.jwtAuthService.apiUrl + this.path}/?cadastroId=${filialPadraoId}`);
  }

  
}
